import { useTranslation } from 'react-i18next'
import { useField } from 'formik'
import calendarIcon from '@iconify-icons/akar-icons/calendar'
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date'
import { PICKER_DATE_FORMAT } from 'config'
import { InputLabel, KeyboardDatePicker } from './DatePicker.style'
import { Icon } from './DatePicker.style'

interface DatePickerProps {
  label?: string | JSX.Element | (string | JSX.Element)[]
  name: string
  disabled?: boolean
  onChange?: () => void
  labelComponent?: typeof InputLabel
}

const DatePicker = ({
  label,
  name,
  disabled,
  labelComponent,
}: DatePickerProps) => {
  const { t } = useTranslation()
  const [field, meta, { setValue }] = useField(name)
  const isError = !!meta.error
  const LabelComponent = labelComponent || InputLabel

  return (
    <>
      <LabelComponent error={!!meta.error} disabled={disabled}>
        {label}
      </LabelComponent>
      <KeyboardDatePicker
        disableToolbar
        disabled={disabled}
        variant="inline"
        format={PICKER_DATE_FORMAT}
        inputVariant="outlined"
        keyboardIcon={
          <Icon disabled={disabled} icon={calendarIcon} isError={isError} />
        }
        placeholder={t('datePlaceholder')}
        value={field.value as string | null}
        autoOk
        name={name}
        error={isError}
        onChange={(e: MaterialUiPickersDate) => {
          setValue(e || null)
        }}
        helperText={meta.error}
      />
    </>
  )
}

export default DatePicker
